<template>
  <div class="class-card">
    <div class="header">
      <div class="class_type"
           v-if="classLabel==='live'">
        <div class="class_ontypeText">直播</div>
      </div>
      <div class="class_type"
           v-else-if="classLabel==='offline'">
        <div class="class_offtypeText">面授</div>
      </div>
      <div class="right flex-center"
           v-if="classStatus">
        <!-- <p>{{classType}}</p> -->
        <p :class="classStatus.style||'hot'"
           style="justify-content: flex-start;padding-left: 15px;">
          <span v-html="classStatus.text"
                v-if="!isAllPlayBackClass"></span>
        </p>
      </div>
      <div class="right flex-center"
           v-if="classStatus"
           style="display:none;">
        <p :class="classStatus.style||'hot'">
          <span v-html="classStatus.text"></span>
        </p>
      </div>
    </div>
    <div class="title"
         :style="classLabel==='live'?'margin-top:50px':''">
      <div class="content">
        <div class="subject flex-center"
             v-if="false"></div>
        <div class="text"
             :class="false?'active':''">
          <span class="sprite-lbqian lianbao-tag"
                v-show="isLianbao"></span>
          {{title}}
        </div>
      </div>
    </div>
    <div v-if="classLabel==='live'"
         class="subtitle">
      <div class="ftitle">{{subTitle}}</div>
    </div>
    <div class="info">
      <div class="row teacher-price"
           v-if="classLabel==='offline'">
        <div class="left">
          <div class="icon">
            <img src="../assets/img/icon/place.png" />
          </div>
          <div class="detail">{{position}}</div>
        </div>
      </div>
      <div class="row date"
           v-if="!!classProcess">
        <div class="icon">
          <img src="../assets/img/icon/calendar.png" />
        </div>
        <div class="detail">{{date}}</div>
        <div class="status">
          <!-- <p class="flex-center">{{classProcess}}</p> -->
          <p>共{{subSum}}节</p>
        </div>
      </div>
      <div class="row teacher">
        <slot v-for="(item, index) in teacherList">
          <div v-if="index < 6"
               :key="index"
               style="margin-top: 4px;margin-right:8px;margin-bottom: 10px;">
            <div class="teacherimg"><img :src="item.picture"
                   alt=""
                   v-if="item.picture">
              <img v-if="!item.picture"
                   :src="item.gender===1?manpic:womanpci">
            </div>
            <div class="teachername">{{item.teacher_name}}</div>
          </div>
        </slot>
      </div>
    </div>
    <!-- 讲座显示价格 价格大于0-->
    <div v-if="classLabel==='live'&&realPrice===0">
      <div class="freenewstyle">
        <span class="original-pricet">免费课程</span>
      </div>
    </div>
    <!-- 正常显示价格 -->
    <div v-else>
      <div class="infobottom"
           v-if="ComponentsStyle != 1"
           :style="isNoAdmin===2&&!isPhone&&isShowShoppingCar===1&&groupState!=1?'justify-content: space-between':''">
        <!-- <i class="fa fa-succeed-cart class-car" ></i> -->
        <button class="btn-add-cart"
                :style="shoppingCarState?'background: #ffffff':''"
                :class="{exists: !disabledBtn, hide: groupState==1}"
                @click.stop="addShoppingCar($event,disabledBtn,goodsId)"
                v-show="isNoAdmin===2&&!isPhone&&isShowShoppingCar===1&&groupState!=1">
          <svg class="fa fa-add-cart"
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               t="1572498113263"
               viewBox="0 0 1024 1024"
               version="1.1"
               p-id="1610"
               style="color: rgba(0,199,191,1);">
            <path :d="disabledBtn?svgNoBuy:svgBuy"
                  :fill="shoppingCarState?'#AEAEAE':'#fff'"
                  p-id="1611" />
          </svg>
        </button>
        <div class="price">
          <span v-if="isShowMaterial"
                style="border-radius: 2px;padding:2px;font-size: 12px;background: rgba(198, 205, 218, 0.3);color: rgba(51, 51, 51, 0.5);">含{{materialPrice}}元教材费</span>
          <span class="original-price"
                v-if="groupState==2&&classLabel === 'live'&&virtual_price">¥{{virtual_price/100}}</span>
          <span class="original-price"
                v-else-if="groupState==1">¥{{price}}</span>
          <span class="discount-price"
                :class="groupState==1?'groupbuy-color':''">
            <span>¥</span>
            <span v-if="groupState==2">{{price}}</span>
            <span v-if="groupState==1">{{groupPrice}}</span>
          </span>
          <i class="fa fa-tuan"
             v-if="groupState==1"></i>
        </div>
      </div>
      <!-- <div class="infobottom" v-if="ComponentsStyle == 1" :style="classLabel === 'live'?'padding-top:12px;':'padding-top:21px;'">
        <div class="newstyle">
          <span class="original-pricet" style="display:none;">原价</span><span class="original-price">¥{{price}}</span>
          <i class="fa fa-tuan" v-if="groupState==1"></i>
          <span class="discount-pricet" :class="groupState==1?'groupbuy-color':''"><span>¥</span>{{realPrice}}</span>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import utils from '@/utils/utils'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    index: Number,
    clickType: Number,
    classType: String,
    classStatus: Object,
    title: String,
    subject: String,
    date: String,
    classProcess: String,
    time: String,
    position: String,
    price: Number,
    class_id: Number,
    realPrice: Number,
    groupState: Number, // 1为团购  2为非团购
    ComponentsStyle: Number,
    groupPrice: Number,
    classLabel: String,
    teacherList: Array,
    subTitle: String,
    subSum: Number,
    virtual_price: Number,
    lecture: String,
    isLianbao: Boolean,
    goodsId: Number,
    carState: Boolean, // true是没有买过 与接口是相反的在传值时已经转换
    cart_exist: Boolean, // 是否在购物车内
    isShowShoppingCar: Number, // 是否显示加购 2为没有,
    isShowMaterial: Boolean, // 教材费是否存在
    materialPrice: Number, // 教材费价格
    isAllPlayBackClass: Boolean // 课程是否结束
  },
  data: function () {
    return {
      isNoAdmin: 2,
      isPhone: false,
      shoppingCarState: true,
      svgNoBuy:
        'M700.494769 776.073846a66.638769 66.638769 0 1 1 0 133.316923 66.638769 66.638769 0 0 1 0-133.316923z m-333.233231 0a66.638769 66.638769 0 1 1 0 133.316923 66.638769 66.638769 0 0 1 0-133.316923z m333.233231 47.261539a19.377231 19.377231 0 1 0 0 38.793846 19.377231 19.377231 0 0 0 0-38.793846z m-333.233231 0a19.377231 19.377231 0 1 0 0 38.793846 19.377231 19.377231 0 0 0 0-38.793846zM157.617231 133.907692a23.630769 23.630769 0 0 1 22.291692 15.753846l0.945231 3.623385 20.48 112.206769c2.087385-0.669538 4.253538-1.181538 6.498461-1.614769l4.844308-0.669538 4.844308-0.236308h371.987692a23.630769 23.630769 0 0 1 3.859692 46.985846l-3.859692 0.275692H217.521231l-1.181539 0.118154a6.695385 6.695385 0 0 0-5.395692 5.632l0.039385 2.126769 66.56 363.204924a6.695385 6.695385 0 0 0 4.726153 5.198769l1.811693 0.275692h494.237538a6.695385 6.695385 0 0 0 6.144-4.017231l0.472616-1.96923 14.099692-131.741539a23.630769 23.630769 0 0 1 47.104 1.181539l-0.078769 3.859692-14.139077 131.780923a53.956923 53.956923 0 0 1-48.482462 47.931077l-5.12 0.236308H284.081231a53.956923 53.956923 0 0 1-51.869539-39.187693l-1.181538-5.001846-0.866462-4.804923-0.669538-2.599385L137.924923 181.169231H78.769231a23.630769 23.630769 0 0 1-3.820308-46.946462L78.769231 133.907692h78.848z m668.199384 10.909539a23.630769 23.630769 0 0 1 23.63077 23.630769l-0.039385 94.523077h94.523077a23.630769 23.630769 0 0 1 3.859692 46.985846l-3.820307 0.275692h-94.562462v94.523077a23.630769 23.630769 0 0 1-19.771077 23.355077l-3.820308 0.275693a23.630769 23.630769 0 0 1-23.630769-23.63077l-0.039384-94.523077h-94.523077a23.630769 23.630769 0 0 1-3.820308-46.946461l3.859692-0.315077h94.483693v-94.523077a23.630769 23.630769 0 0 1 19.810461-23.315692z',
      svgBuy:
        'M700.494769 776.073846a66.638769 66.638769 0 1 1 0 133.316923 66.638769 66.638769 0 0 1 0-133.316923z m-333.233231 0a66.638769 66.638769 0 1 1 0 133.316923 66.638769 66.638769 0 0 1 0-133.316923z m333.233231 47.261539a19.377231 19.377231 0 1 0 0 38.793846 19.377231 19.377231 0 0 0 0-38.793846z m-333.233231 0a19.377231 19.377231 0 1 0 0 38.793846 19.377231 19.377231 0 0 0 0-38.793846zM157.617231 133.907692a23.630769 23.630769 0 0 1 23.236923 19.377231l20.48 112.206769c2.087385-0.669538 4.253538-1.181538 6.498461-1.614769l4.844308-0.669538 4.844308-0.236308h371.987692a23.630769 23.630769 0 0 1 3.859692 46.985846l-3.859692 0.275692H217.521231l-1.181539 0.118154a6.695385 6.695385 0 0 0-5.395692 5.632l0.039385 2.126769 66.56 363.204924a6.695385 6.695385 0 0 0 4.726153 5.198769l1.811693 0.275692h494.237538a6.695385 6.695385 0 0 0 6.144-4.017231l0.472616-1.96923 14.099692-131.741539a23.630769 23.630769 0 0 1 47.104 1.181539l-0.078769 3.859692-14.139077 131.780923a53.956923 53.956923 0 0 1-48.482462 47.931077l-5.12 0.236308H284.081231a53.956923 53.956923 0 0 1-51.869539-39.187693l-1.181538-5.001846-0.866462-4.804923-0.669538-2.599385L137.924923 181.169231H78.769231a23.630769 23.630769 0 1 1 0-47.261539z m804.391384 85.779693a23.630769 23.630769 0 0 1 2.599385 30.12923l-2.756923 3.268923-158.956308 157.538462a23.630769 23.630769 0 0 1-32.610461 0.669538l-2.796308-3.072-77.351385-101.100307a23.630769 23.630769 0 0 1 34.973539-31.586462l2.599384 2.875077 60.967385 79.753846 139.933539-138.633846a23.630769 23.630769 0 0 1 33.398153 0.157539z',
      manpic: require('@/assets/img/class/teacher-nan.png'),
      womanpci: require('@/assets/img/class/teacher-nv.png')
    }
  },
  methods: {
    ...mapActions(['addCar']),
    // 检测设配
    checkPhone () {
      this.isPhone = document.body.clientWidth < 767
    },
    addShoppingCar (e, state, goodsId) {
      const $element = $(e.currentTarget)
      if (!this.$parent.isLogin) {
        this.$parent.goLogin()
        return
      }
      if (state === false || this.groupState === 1) {
        return false
      }
      // if (this.isLianbao) {
      //   this.$parent.cardInfo = {
      //     title: this.title,
      //     class_id: this.class_id,
      //     goods_type: this.classLabel === 'live' ? 2 : 5
      //   }
      //   this.$parent.cardInfo.goods_id = goodsId
      //   this.$parent.cardInfo.class_id = this.class_id
      //   this.$parent.goods_id = goodsId
      //   this.$parent.showLianBao($element, this.index, this.clickType)
      //   return false
      // }
      this.addCar({
        goodsIds: [goodsId],
        goodsType: this.classLabel === 'live' ? 2 : 5,
        callback: () => {
          this.shoppingCarState = false
          utils.ballAnimation($element)
        }
      })
    }
  },
  created () {
    this.shoppingCarState = this.carState
    this.checkPhone()
    this.isNoAdmin = this.userInfo.role === 1 ? 1 : 2
  },
  computed: {
    disabledBtn () {
      return this.shoppingCarState
    },
    ...mapState({
      isLogin: state => state.user.isLogin,
      userInfo: state => state.user.userInfo,
      moresgstate: state => state.moresg.moresgstate
    })
  },
  watch: {
    carState () {
      this.shoppingCarState = this.carState
    }
  }
}
</script>
<style lang="scss">
.shopping-ball {
  position: fixed;
  width: 34px;
  height: 34px;
  // top: 200px;
  background: url("../assets/img/pay/lil-tv.png") center no-repeat;
  // background: red;
  background-size: contain;
  z-index: 9999;
  // animation: cartAnimation 10s cubic-bezier(0.01, 0.76, 0.99, 0.19);
  &.fast {
    animation: (cartAnimation 0.4s linear);
  }
  &.normal {
    animation: (cartAnimation 0.5s linear);
  }
  &.slow {
    animation: (cartAnimation 0.6s linear);
  }
  // animation: cartAnimation 10s linear;
  // &.transition{
  //     @include transition(left ease 1.2s, top cubic-bezier(0.07, 0.51, 0.52, 0.96) 1.2s, opacity ease 1.2s, transform ease 1.2s);
  // }
}
@keyframes cartAnimation {
  0% {
    opacity: (0);
    transform: (scale(0.6));
  }

  30% {
    opacity: (1);
    transform: (scale(1));
  }

  70% {
    opacity: (1);
    transform: (scale(1));
  }

  100% {
    opacity: (0);
    transform: (scale(0.6));
  }
}
</style>
<style lang="scss" src="../assets/scss/_lianbao_tag.scss"></style>
<style scoped lang="scss">
@import "@/assets/scss/_base.scss";
// .normal {
//   text-align: center;
//   transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
// }

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen {
  >>> .class-card {
    min-height: 311px;
  }
}
.class-card {
  width: 370px;
  height: 311px;
  box-sizing: border-box;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px #dbe0e4;
  padding:1px;
  cursor: pointer;
  position: relative;
  .class_type {
    width: 62px;
    height: 88px;
    overflow: hidden;
    position: absolute;
    top: 0px;
    right: 0px;
    .class_ontypeText {
      font: bold 15px Sans-Serif;
      transform: rotate(45deg);
      color: #333;
      text-align: center;
      position: relative;
      padding: 2px 20px;
      left: -11px;
      top: 11px;
      width: 100px;
      background-color: rgba(0, 199, 191, 0.1);
      color: #6a6340;
      // -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
      // box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
      font-size: 12px;
      color: rgba(0, 199, 191, 1);
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
    }
    .class_offtypeText {
      font: bold 15px Sans-Serif;
      transform: rotate(45deg);
      text-align: center;
      position: relative;
      padding: 2px 20px;
      left: -11px;
      top: 11px;
      width: 100px;
      background-color: rgba(255, 160, 0, 0.1);
      color: rgba(255, 160, 0, 1);
      // -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
      // box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
      font-size: 12px;
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    .left {
      width: 68px;
      height: 35px;
      background: linear-gradient(
        308deg,
        rgba(56, 211, 205, 1) 0%,
        rgba(0, 199, 191, 1) 100%
      );
      border-radius: 6px 0px 12px 0px;
      p {
        width: 36px;
        height: 14px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 14px;
      }
    }
    .right {
      width: 230px;
      height: 35px;
      border-radius: 2px;
      padding-right: 16px;
      .fulled {
        width: 100%;
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: #d8d8d8;
        line-height: 16px;
        display: flex;
        justify-content: flex-end;
      }
      .almostFull {
        width: 100%;
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(253, 83, 83, 1);
        line-height: 16px;
        display: flex;
        justify-content: flex-end;
      }
      .hot {
        width: 100%;
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 160, 0, 1);
        line-height: 16px;
        display: flex;
        justify-content: flex-end;
      }
      .notStart {
        width: 100%;
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(10, 201, 193, 1);
        line-height: 16px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .title {
    margin-top: 21px;
    margin-right: 16px;
    .content {
      display: flex;
      text-align: left;
      height: 50px;
      position: relative;
      .subject {
        position: absolute;
        left: 16px;
        top: 0px;
        min-width: 40px;
        height: 24px;
        background: url("../assets/img/lbqian.png") no-repeat;
        font-size: 12px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      .text {
        // text-indent: 20px;
        margin-left: 16px;
        line-height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
  .subtitle {
    font-size: 14px;
    font-family: $family;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.5);
    line-height: 14px;
    padding-left: 16px;
    margin-bottom: 18px;
    .ftitle {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .info {
    // margin-bottom: 20px;
    margin-left: 19px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(44, 45, 46, 1);
    position: relative;
    .teacher {
      margin: 13px 0px 23px 0px;
      div {
        display: flex;
        flex-direction: column;
      }
      .teacherimg {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        // background: skyblue;
      }
      .teachername {
        margin-top: 9px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.8);
        font-family: $family;
        width: 48px;
        height: 16px;
        overflow: hidden;
      }
      img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }
    }
    .row {
      display: flex;
      margin-bottom: 8px;
      align-items: center;
      .icon {
        width: 15px;
        height: 15px;
        margin-right: 9px;
        img {
          height: 15px;
          width: 15px;
        }
      }
      .status {
        width: 70px;
        height: 12px;
        border-radius: 1px;
        margin-left: 8px;
        border-left: 1px solid rgba(51, 51, 51, 0.5);
        line-height: 12px;
        padding-left: 9px;
        p {
          font-size: 12px;
          font-weight: 500;
          color: rgba(51, 51, 51, 0.5);
        }
      }
      .teacher {
        max-width: 280px;
      }
      .time {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .teacher-price {
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
      }
      .price {
        margin-right: 16px;
        height: 26px;
        font-size: 26px;
        font-weight: 500;
        color: rgba(255, 160, 0, 1);
        line-height: 26px;
        position: absolute;
        right: 0;
        bottom: -4px;
      }
    }
  }
}
.active {
  text-indent: 45px;
}
.groupbuy-color {
  color: #ef4d3c;
}
.infobottom {
  padding-top: 12px;
  width: 91%;
  border-top: 1px solid rgba(51, 51, 51, 0.06);
  box-sizing: border-box;
  text-align: right;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  color: #ffa000;
  display: flex;
  // justify-content: space-between;
  .btn-add-cart {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    color: rgba(51, 51, 51, 0.1);
    border: 1px solid;
    font-size: 26px;
    padding: 0;
    cursor: pointer;
    outline: none;
    line-height: 1;
    &:hover {
      // color: $brand-success;
      // transition: (all 0.3s);

      path {
        fill: rgba(0, 199, 191, 1);
        transition: (all 0.3s);
      }
    }
    &.hide {
      cursor: default;
      border: 0;
    }
  }
  .exists {
    color: #fff;
    background: rgba(51, 51, 51, 0.16);
    border-color: transparent;
    transition: all 0.6s ease;
    cursor: not-allowed;

    &:hover {
      color: #fff;

      path {
        fill: #fff;
        transition: all 0.3s;
      }
    }
  }

  i {
    font-size: 26px;
    color: red;
  }
  .newstyle {
    display: flex;
    align-items: center;
  }
  .class-car {
    border: 1px solid;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 4px;
    border-color: rgba(51, 51, 51, 0.1);
    color: rgba(51, 51, 51, 0.5);
  }
}
.freenewstyle {
  color: #ffa000;
  text-align: right;
  padding-right: 14px;
  font-size: 14px;
  font-weight: 500;
  padding-top: 18px;
  margin-top: 15px;
  border-top: 1px solid rgba(51, 51, 51, 0.06);
}
.original-price {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  opacity: 0.3;
  margin: 0px 4px;
  text-decoration: line-through;
}
.discount-price {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  margin: 0px 3px 0px 10px;
  span:nth-child(1) {
    margin-right: 3px;
    font-size: 16px;
  }
}
.discount-pricet {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  // color: #EF4D3C;
  margin: 0px 3px 0px 10px;
  span {
    margin-right: 3px;
    font-size: 25px;
  }
}
</style>
